<template>
    <div>
        <vx-card class="widget" title="Split Action" title-color="black">
            <div>
                <vs-row>
                    <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="pl-0 pr-1 mb-3">
                        <SelectForeign :model.sync="data.share" label="Select by Share" placeholder="Type to Search"
                            :multiple="false" :load_initial="true" :label_keys="['name',]" label_class="mb-0"
                            input_class="mt-0 bg-white" :show_id_in_label="false" list_length="10000"
                            :endpoint="$store.state.apiendpoints.share_list" :use_id_as_value="true" :disabled="loading" 
                        />
                        <small class="block text-danger mt-1" v-if="api_errors && api_errors.share">
                            {{ api_errors.share.join(', ') }}
                        </small>
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="pl-0 pr-1 mb-3">
                        <SelectDate :selectedDate.sync="data.applicable_date" label="Applicable Date"
                            placeholder="Select Date" />
                        <small class="block text-danger mt-1" v-if="api_errors && api_errors.applicable_date">
                            {{ api_errors.applicable_date.join(', ') }}
                        </small>
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="pl-0 pr-1 mt-2 mb-3">
                        <label class="vs-input--label block">Split Factor</label>
                        <div class="flex" style="align-items: center">
                            <vs-input v-model="data.action_info.split_factor" type="number" min="1" class="w-full"
                                :disabled="loading" />
                        </div>
                        <small class="block text-danger mt-1" v-if="api_errors && api_errors.split_factor">
                            {{ api_errors.split_factor.join(', ') }}
                        </small>
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="pl-0 pr-1 mt-3 mb-3">
                        <vs-button class="w-full" @click="save" color="primary" type="filled"
                            :disabled="loading">Submit</vs-button>
                    </vs-col>
                </vs-row>
            </div>
        </vx-card>
    </div>
</template>

<script>
import { Request } from "../../utils/requests";

export default {
    props: {
        embedded_mode: {
            default: false,
        },
        embedded_filters: {
            default: null,
        },
    },
    data() {

        return {
            loading: false,
            data: {
                action_info: {
                    split_factor: null
                },
                corporate_action_type: "split",
                share: null,
                applicable_date: null,
            },
            api_errors: {}
        };
    },
    mounted() {
        this.init()
    },
    watch: {
        '$route.params.split_id'(newV) {
            this.init()
        },
    },
    methods: {
        init() {
            this.split_id = this.$route.params.split_id
            if (this.$route.params.split_id) {
                this.loadData()
            }
        },
        loadData() {
            this.loading = true

            Request(this, 'GET', this.$store.state.apiendpoints.corporate_action_rud + this.split_id + "/").then(
                (res) => {
                    this.data = res
                    this.bonus_id = res.id
                    this.loading = false
                },
                (err) => {
                    this.$vs.notify({
                        time: 2500,
                        title: 'Unknown Error',
                        text: 'An Error Occured. Please Try Again',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                    this.$router.push("/");
                }
            )
        },
        checking_for_required_fields() {
            if (!this.data.share) {
                this.api_errors = {
                    "share": [
                        "Share is required.",
                    ]
                }
                return true
            }
            if (!this.data.applicable_date) {
                this.api_errors = {
                    "applicable_date": [
                        "Applicable Date is required.",
                    ]
                }
                return true
            }


            if (!this.data.action_info.split_factor) {
                this.api_errors = {
                    "split_factor": [
                        "Split Factor is required.",
                    ]
                }
                return true
            }

            return false
        },
        save() {

            if (this.checking_for_required_fields()) return

            let $this = this
            let url = $this.$store.state.apiendpoints.corporate_action, request_method = "POST";
            if (this.split_id) {
                url = $this.$store.state.apiendpoints.corporate_action_rud + this.split_id + "/";
                request_method = "PUT";
            }

            this.submit_disabled = true
            Request($this, request_method, url, null, this.data).then(
                (res) => {
                    $this.$vs.notify({
                        time: 2500,
                        title: 'Saved',
                        text: 'Saved Successfully',
                        iconPack: 'feather',
                        icon: 'icon-check',
                        color: 'success'
                    })
                    this.submit_disabled = false
                    $this.$router.push({ name: 'corporate-action-list' })
                },
                (err) => {
                    if (err.error) {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: 'Please check all fields and Try Again.',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                        this.api_errors = err.error
                    } else {
                        $this.$vs.notify({
                            time: 2500,
                            title: 'Unknown Error',
                            text: 'An Error Occured. Please Try Again',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                    this.submit_disabled = false
                }
            );
        }
    }
};
</script>